/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2025, Bulb Inc. For more information, please email contact@hellobulb.com.
 *          _
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TranslocoModule } from '@jsverse/transloco';
import { SearchFormComponent } from './search-form.component';
import { SearchService } from './search.service';

/**
 * Search module that provides search functionality
 */
@NgModule({
  declarations: [SearchFormComponent],
  exports: [SearchFormComponent],
  imports: [CommonModule,
    FormsModule,
    TranslocoModule],
  providers: [SearchService, provideHttpClient(withInterceptorsFromDi())],
})
export class SearchModule {}
